import React, { useState, useEffect } from "react";

export const svg = `<svg width="33" height="32" viewbox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M30.7 12.402a3.582 3.582 0 0 1 1.312 4.895l-7.168 12.411a3.585 3.585 0 0 1-4.896 1.311l-16.635-9.6a2.25 2.25 0 0 1-1.104-1.641L.493 7.38l11.599-4.714a2.252 2.252 0 0 1 1.973.136l16.636 9.6ZM6.317 9.59a1.527 1.527 0 1 1-3.054 0 1.527 1.527 0 0 1 3.054 0Zm11.92 1.729.958-1.595 1.768 1.062-.946 1.573.188.173c.75.694 1.1 1.433 1.193 2.156.08.617-.027 1.242-.26 1.838L19.3 15.422a1.58 1.58 0 0 0-.058-.922c-.16-.407-.51-.774-1.087-1.121-.55-.33-1.02-.462-1.417-.42a1.12 1.12 0 0 0-.865.548.808.808 0 0 0-.124.521c.022.18.106.337.207.475.161.221.428.47.742.763l.181.17c1.168 1.092 1.93 1.937 2.273 2.727.167.386.232.754.195 1.13-.038.378-.18.785-.457 1.244-.52.866-1.207 1.284-1.926 1.432-.731.15-1.519.026-2.224-.238l-.245-.092-.94 1.564-1.768-1.061.968-1.61-.18-.173c-1.408-1.353-1.472-2.917-1.007-4.206l1.834 1.1c-.085.413-.078.808.103 1.193.21.446.627.824 1.254 1.201.491.295.937.459 1.33.454a1.08 1.08 0 0 0 .95-.547.865.865 0 0 0 .126-.625c-.04-.21-.16-.4-.307-.58-.218-.267-.57-.59-1.024-1.01a50.97 50.97 0 0 1-.455-.421c-.676-.628-1.285-1.288-1.591-2.01-.296-.698-.317-1.47.224-2.37.903-1.501 2.491-1.774 3.988-1.295l.237.076Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
